<template>
  <div id="app" class="container" style="overscroll-behavior-y: none;">
    <div class="header" id="header2">
      <div><img src="../../assets/css/icon/fh.png" class="left" @click="goBack"/></div>
      <div></div>
    </div>
    <div class="balck" @click="goBack" style="margin-left: -15px;">
      <img src="../../assets/css/icon/fh.png" alt="" >

      <span>{{ $t("return") }}</span>
    </div>
    <div class="content_box">
      <div class=" w-full h-full">
        <div class="flex items-center space-x-6">
          <i class="fas fa-bell text-gray-400 hover:text-white"></i>
          <i class="fas fa-globe text-gray-400 hover:text-white"></i>
          <i class="fas fa-moon text-gray-400 hover:text-white"></i>
        </div>
      </div>

      <div class=" mx-auto px-4 py-8">
        <div class="text-3xl font-semibold mb-2" style="font-weight: 700">{{ $t("become_leader") }}</div>
        <p class="text-gray-400 mb-6 pc_text" style="font-weight: 700">{{ $t("commission_and_profit_sharing") }}</p>
        <div class="text-gray-400 mb-6 mobile_text" style="font-weight: 700">{{ $t("commission_and_profit_sharing") }}</div>

        <div class="flex userInfo_box" style="align-items: center">
          <img class="rounded-full" :src="userInfo.userImg" alt="User Avatar" >
          <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="handleChange"
          />
          <div class="text-lg pc_box">{{ userInfo.username }}</div>
          <div class="text-lg mobile_box mobile_userInfo_box">
            <div class="name">{{ userInfo.username }}</div>
<!--            <div class="text">{{ $t("add_project_bio") }}</div>-->
          </div>
          <div class="ml-auto" @click="open()">
            <img src="../../assets/imgs/edit.svg" alt="">
          </div>
        </div>

        <div class="mb-4 ">
          <div v-html="parseHtml(userInfo.des)" class="text-yellow-400"></div>
          <div class="select_content_box items-center space-x-2">
            <div class="lable_box">{{ $t("trading_currency") }}:</div>
            <div style="  position: relative;">
              <div id="showOptionTag" @click="optionShow=true" class="el_select_box showArea" slot="reference">
                <div class="el_select_icon_head showArea">{{ activeChooseOption[0] }}</div>
                <div class="el_select_text showArea" style="white-space: nowrap;">{{ activeChooseOption }}</div>
                <div class="icon showArea" style="margin-left: 30px">
                  <svg t="1745824931143" class="icon" viewBox="0 0 1024 1024" version="1.1"
                       xmlns="http://www.w3.org/2000/svg" p-id="10085" width="200" height="200">
                    <path
                        d="M573.056 752l308.8-404.608A76.8 76.8 0 0 0 820.736 224H203.232a76.8 76.8 0 0 0-61.056 123.392l308.8 404.608a76.8 76.8 0 0 0 122.08 0z"
                        fill="#EAECEF" p-id="10086"></path>
                  </svg>
                </div>
              </div>
              <div class="option_box showArea" style="padding-right: 40px" v-show="optionShow" id="showOption">
                <div class="option_select_box showArea" @click="chooseOption(item,index)"
                     v-for="(item,index) in this.userInfo.currency" :key="item.value">
                  <div class="el_select_icon_head showArea">{{ item.label[0] }}</div>
                  <div class="el_select_text showArea"> {{ item.label }}</div>
                </div>
              </div>
            </div>
            <div class="token pc_token"><span
                v-if="userInfo.currency.length>0">{{ selectToken }}</span></div>
          </div>
          <div class="select_content_box">
            <div class="lable_box">{{ $t("profit_sharing_ratio") }}:</div>
            <div class="input_rate">
              <input type="number" v-model="rate" placeholder="0-20" class="input_rate_input"
                                           min="0"/>%
            </div>
          </div>
        </div>

        <div class="bottom" style="margin-bottom: 100px;">
          <div class="mb-6 des-content" style="margin-top: 33px;">
            <p class="text-sm text-gray-400">{{ $t("note") }}</p>
            <div class="list-decimal text-gray-400" >
              <div class="text_main_box">
                <div class="n">1、</div>
                <div class="r">{{ $t("signal_provider_rules_1") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">2、</div>
                <div class="r">{{ $t("signal_provider_rules_2") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">3、</div>
                <div class="r">{{ $t("signal_provider_rules_3") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">4、</div>
                <div class="r">{{ $t("signal_provider_rules_4") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">5、</div>
                <div class="r">{{ $t("signal_provider_rules_5") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">6、</div>
                <div class="r">{{ $t("signal_provider_rules_6") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">7、</div>
                <div class="r">{{ $t("signal_provider_rules_7") }}</div>
              </div>
              <div class="text_main_box">
                <div class="n">8、</div>
                <div class="r">{{ $t("signal_provider_rules_8") }}</div>
              </div>
            </div>
          </div>

          <div class="flex checkbox_content_box items-center mb-6">
            <input class="checkbox" type="checkbox" v-model="checkbox" id="agreement">
            <span>{{ $t("agree_terms") }}</span>
          </div>

          <button @click="affirm()" class="btn">
            {{ $t("submit") }}
          </button>
        </div>
      </div>
    </div>
    <el-dialog :modal="false" :title="$t('edit_profile')" :visible.sync="dialogVisible" width="485px">
      <div class="demo-input-suffix">
        <div class="lable"> {{ $t("avatar") }}</div>
        <img class="rounded-full" :src="userInfo.userImg" @click="upload" alt="User Avatar">

      </div>
      <div class="demo-input-suffix">
        <div class="lable"> {{ $t("nickname") }}</div>
        <el-input
            type="text"
            :placeholder="$t('enter_content')"
            v-model="userInfo.username"
            maxlength="60"
            show-word-limit
        ></el-input>
      </div>
      <div class="demo-input-suffix" style="margin-top: -10px">
        <div class="lable"></div>
        <span class="text">{{ $t("nickname_change_limit") }}</span>。
      </div>
      <div class="demo-input-suffix" style="align-items: revert">
        <div class="lable"> {{ $t("bio") }}</div>
        <el-input
            type="textarea"
            :placeholder="$t('add_project_bio')"
            v-model="userInfo.des"
            maxlength="256"
            show-word-limit
            style="background:rgba(94, 102, 115,0.3);"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("cancel") }}</el-button>
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
      </span>
    </el-dialog>
    <share ref="share" :contract="this.$route.query.contract" :token="this.$route.query.token"></share>
  </div>
</template>

<script>
import {
  createAndCall,
  estimateAndSend,
  getAllTokenFromCache,
  getContractWithCache,
  getErc20Info
} from "../../utils/contract";
import {Contract, Method} from "../../config/const";
import {getAccount, requestAccount, sleep} from "../../utils/wallet";
import Share from "../../components/share.vue";
import {isMobile} from "../../utils/functions";
import axios from "axios";

export default {
  components: {Share},
  data() {
    return {
      userInfo: {
        username: 'Fufu XX',
        userImg: require("@/assets/css/icon/head.svg"),
        type: 0,
        number: '22,225.30',
        yield: '+36.81%',
        scale: '106.639.64',
        day7: '18.01%',
        currency: [],
        molecule: '102',
        denominator: '400',
        des: '',
      },

      userInfoCurrency: 0,
      checkbox: false,
      dialogVisible: false,
      optionShow: false,
      text: '',
      selectToken:"",
      textarea: '',
      activeChooseOption: ' ',
      outSideClick: undefined,
      rate: "",

    };
  },
  created() {
    this.getAllToken()
    this.initParams()
  },
  mounted() {
    this.hideTopAndBottom()
    this.outSideClick = this.setupClickOutside();

  },
  unmounted() {
    if (this.outSideClick) {
      this.outSideClick();
    }
  }
  ,

  methods: {
    async initParams(){
      if(!this.$route.query.contract){
        return;
      }
      const info=await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress, [this.$route.query.contract]],3600000,createAndCall);
      this.userInfo.username=info.traderName;
      const des=info.traderDescription;
      const desArr=des.split("$^");
      let headUrl="";
      if(desArr.length>1){
        headUrl=desArr[desArr.length-1];
      }
      if(headUrl){
        if(headUrl.startsWith("http")){
          this.userInfo.userImg=headUrl;
        }else{
          this.userInfo.userImg="https://admin.fufuture.io"+headUrl;
        }
      }
      this.userInfo.des = this.parseHtml(desArr[0] ? desArr[0] : "--")

      if(this.$route.query.token){
        this.selectToken=this.$route.query.token;
      }
      if(this.$route.query.tokenName){
        this.activeChooseOption=this.$route.query.tokenName;
      }
      if(this.$route.query.rate){
        this.rate=this.$route.query.rate;
      }
    },
    affirm() {
      if (!this.checkbox) {
        this.$message(this.$t('click_to_confirm_reading'));
        return false
      }
      if (this.rate < 0 || this.rate > 20) {
        this.$message(this.$t("enter_correct_profit_sharing_ratio"));
        return false;
      }
      this.addToken()
    },
    shareOpen() {
      this.$refs.share.show(this.userInfo.username, 0, 0, 0);
    },
    async getAllToken() {
      await requestAccount();
      this.userInfo.currency = await getAllTokenFromCache();
      if(!this.selectToken){
        this.selectToken=this.userInfo.currency[0].value;
        this.activeChooseOption = this.userInfo.currency[0].label;
      }
    },
    async addToken() {
      let address = await getAccount()
      let currentInfo = this.selectToken;
      if (!currentInfo || !address) {
        return await this.$message.error(this.$t("no_trading_currency_selected"));
      }
      if (!this.rate) {
        return await this.$message.error(this.$t("enter_profit_sharing_ratio"));
      }
      if(this.userInfo.des.length>256){
        return this.$message.error("Strings is too long.");
      }
      if(this.$route.query.contract){
        let tx = await estimateAndSend(Contract.LeadingContractFactory, Method.updateTraderInfo, [this.selectToken, this.userInfo.username, this.userInfo.des+"$^"+this.userInfo.userImg]);
        let info =await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress, [this.$route.query.contract]],3600000,createAndCall,true);
      }else{
        let tx = await estimateAndSend(Contract.LeadingContractFactory, Method.createLeadingContract, [this.selectToken, this.rate, this.userInfo.username, this.userInfo.des+"$^"+this.userInfo.userImg]);
      }
      await sleep(1000);
    },
    open() {
      this.dialogVisible = true
    },
    ok1() {
      this.dialogVisible = false

    },
    parseHtml(content) {
      return content.replace("\n", "<br/>");
    },
    chooseOption(a, index) {
      this.activeChooseOption = a.label
      this.optionShow = false
      this.userInfoCurrency = index;
      this.selectToken=a.value;
    },
    hideTopAndBottom() {

      if (!isMobile()) {
        document.getElementById("header2").style.display = "none";

        document.getElementById("header").style.display = "flex";
        document.getElementById("footer").style.display = "flex";
      } else {
        document.getElementById("header").style.display = "none";
        document.getElementById("footer").style.display = "none";

        document.getElementById("header2").style.display = "flex";

      }

    },
    setupClickOutside() {

      let showArea = document.querySelector(".showArea");
      const handleClickOutside = (event) => {
        if (!showArea.contains(event.target)) {
          this.optionShow = false;
        }
      };

      document.addEventListener('click', handleClickOutside);

      // 返回清理函数
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    },
    goBack() {
      // this.$router.push({path: "/"})
      this.$router.back();
    },
    upload() {
      this.$refs.fileInput.click()
    },

    // 选择文件
    async handleChange(e) {
      const file = e.target.files[0]
      if (!file) return

      // ✅ 校验类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('只能上传图片')
        return
      }

      // ✅ 校验大小（2MB）
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片不能超过2MB')
        return
      }

      const localUrl = URL.createObjectURL(file)
      const old=this.userInfo.userImg;
      this.userInfo.userImg = localUrl


      try {
        this.$store.commit('setLoading', true)
        setTimeout(() => {
          this.$store.commit('setLoading', false)
        }, 30000)
        const formData = new FormData()
        formData.append('file', file)

        const res = await axios.post('https://admin.fufuture.io/fn.php?action=upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        if(res.data.error){
          this.$message.error(res.data.error);
          this.userInfo.userImg=old;
          return;
        }

        // ✅ 假设后端返回 { url: 'xxx' }
        this.userInfo.userImg = res.data.url
        this.$message.success("Upload success");

      } catch (err) {
        console.error(err)
        this.$message.error('Upload failed')
        this.userInfo.userImg=old;
      }
      this.$store.commit('setLoading', false)
    }


  },
};
</script>
<style src="../../assets/list.scss" lang="scss" scoped></style>
<style scoped lang="scss">
@font-face {
  font-family: 'HarmonyOS Sans SC';
  src: url('https://upload.fufuture.io/tff/HarmonyOS_Sans_SC_Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'HarmonyOS Sans SC';
  src: url('https://upload.fufuture.io/tff/HarmonyOS_Sans_SC_Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'HarmonyOS Sans SC';
  src: url('https://upload.fufuture.io/tff/HarmonyOS_Sans_SC_Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'HarmonyOS Sans SC';
  src: url('https://upload.fufuture.io/tff/HarmonyOS_Sans_SC_Light.ttf') format('truetype');
  font-weight: 300;
  font-style: normal;
}

.header {
  padding-top: 10px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  background: black;
  z-index: 2000;

  .left {
    margin-left: 15px;
  }

  .right {
    margin-right: 15px;
  }
}

.container {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  margin-top: 120px;
  padding-top: 0px;
}

.content_box {
  width: 588px;
  margin: 0 auto;
}

.flex {
  display: flex;
}

.text-3xl {
  font-family: 'HarmonyOS Sans SC';
  font-weight: 700;
  font-size: 33px;
  margin-bottom: 8px;
  letter-spacing: -1px;
  line-height: 38.68px;
  color: rgba(234, 236, 239, 1);
}

.text-gray-400 {
  font-family: 'HarmonyOS Sans SC';
  font-weight: 400;
  opacity: 1;
  font-size: 13px;
  letter-spacing: 0.5px;
  line-height: 22px;
  color: rgba(133, 142, 155, 1);
  text-align: left;
  vertical-align: top;
}

.userInfo_box {
  margin-top: 32px;

  .rounded-full {
    width: 70px;
    min-width: 70px;
    height: 70px;
    border-radius: 50%;
    opacity: 1;
  }

  .text-lg {
    font-family: 'HarmonyOS Sans SC';
    font-weight: 500;
    font-size: 20px;
    vertical-align: top;
    color: #ffffff;
    width: 100%;
    line-height: 75px;
    margin-left: 22px;
  }

  .ml-auto {
    cursor: pointer;
    margin-top: 10px;
    img {
      width: 36px;
      height: 36px;
    }
  }

  .mobile_token {
    display: none !important;
  }

}

.mb-4 {
  margin-top: 28px;

  .text-yellow-400 {
    font-size: 14px;
    line-height: 16.41px;
    color: rgba(198, 254, 97, 1);
  }
}

.select_content_box {
  margin: 23px 0;
  display: flex;
  align-items: center;

  .select_box {
    background-color: rgba(24, 26, 32, 1) !important;
    color: #ffffff;
    border: 1px solid rgba(198, 254, 97, 0.5);
    border-radius: 4px;
    outline: none;
    margin-left: 10px;
    width: 120px;
    font-size: 14px;
    padding: 2px 0;
  }
}

.checkbox_content_box {
  display: flex;
  align-items: center;
  margin-top: 26px;

  input {
    background-color: rgba(24, 26, 32, 1) !important;
    margin-right: 10px;
    color: rgba(24, 26, 32, 1) !important;
  }

  span {
    font-weight: 500;
    font-size: 16px;
  }

}

.input_rate {
  width: 470px;
  display: flex;
  align-items: center;
  height: 36px;
  border: 1px solid rgba(198, 254, 97, 0.5);
  border-radius: 8px;
  padding-left: 12px;
  padding-right: 12px;
}

.input_rate_input {
  background: transparent;
  border: none;
  color: white;
  flex: 1;
  font-size: 13px;
}

.input_rate_input:focus {
  outline: none;
}

.btn {
  font-family: 'HarmonyOS Sans SC';
  font-weight: 600;
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background: rgba(198, 254, 97, 1);
  font-size: 16px;
  line-height: 48px;
  color: rgba(24, 26, 32, 1);
  text-align: center;
  outline: none;
  border: 0;
  cursor: pointer;
  margin-top: 23px;
}

.list-decimal {
  line-height: 30px;
  font-weight: 400;
  margin-top: 14px;
  height: 200px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 4px;
  }
}

::v-deep .el-dialog {
  background: #1E2329 !important;
  box-shadow: 0px 10px 25px #000000 !important;
}

::v-deep .el-dialog__headerbtn .el-dialog__close:hover {
  color: #ffffff;
}

.demo-input-suffix {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .lable {
    width: 88px;
    font-size: 14px;
    font-weight: 700;
    color: rgba(234, 236, 239, 1);
  }

  .rounded-full {
    width: 89.92px;
    height: 83.88px;
  }

  .text {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.41px;
    color: rgba(132, 142, 156, 1);
  }
}

::v-deep .el-input__inner {
  border: 1px solid #848E9C !important;
  height: 48px;
  line-height: 48px;
  text-align: left;
}

::v-deep .demo-input-suffix .el-input__inner {
  color: #ffffff !important;
  background: transparent !important;
  border: 1px solid #848E9C !important;
  border-radius: 10px;

}

::v-deep .el-textarea .el-textarea__inner {
  color: #ffffff !important;
  background: transparent !important;
  border: 0;
}

::v-deep .el-textarea {
  border-radius: 10px;
  height: 120px;
}

::v-deep .el-textarea .el-textarea__inner {
  height: 120px;
}

::v-deep .demo-input-suffix .el-textarea .el-input__count {
  background: transparent !important;
  color: rgba(234, 236, 239, 1);
}

::v-deep .el-input .el-input__count .el-input__count-inner {
  background: transparent !important;
}

::v-deep .el-dialog__footer {
  display: flex !important;
  width: 100%;

  .el-button {
    width: 217px;
    height: 40px;
    opacity: 1;
    border-radius: 6px;
    background: #5E6673;
    border: 0;
    outline: none;
    color: #EAECEF;
  }
}

.lable_box {
  margin-top: 3px;
  font-size: 16px;
  margin-right: 10px;
  color: rgba(234, 236, 239, 1);
  font-weight: 700;
}

.token {
  margin-left: 20px;
  background-color: rgba(44, 49, 56, 1);
  font-weight: 400;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  line-height: 36px;

  span {
    margin-top: 2px;
  }
}

.el_select_box {
  display: flex;
  //width: 120px;
  height: 36px;
  opacity: 1;
  border-radius: 8px;
  background: rgba(24, 26, 32, 1);
  border: 1px solid rgba(198, 254, 97, 0.5);
  align-items: center;
  padding: 0 16px;

  box-sizing: border-box;

  .icon {
    svg {
      width: 10px;
      height: 10px;
      text-align: right;
    }
  }

}

.option_box {
  position: absolute;
  //width: 120px;
  max-height: 300px;
  overflow-y: auto;
  opacity: 1;
  border-radius: 0px 0px 10px 10px;
  background: #1E2329;
  box-shadow: 0px 10px 25px #000000;
  top: 28px;
  left: 0px;

  .option_select_box {
    height: 28px;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .option_select_box:hover {
    background-color: #2C3138;
  }
}

.el_select_icon_head {
  width: 16px;
  height: 16px;
  border: 0.5px solid #E5E5E5;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  min-width: 16px;
  margin-right: 7px;
}

.el_select_text {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
}

.option_select_box {
  display: flex;
}

::v-deep .el-dialog {
  border-radius: 10px;
  box-shadow: 0px 10px 25px rgb(0, 0, 0, 0.25);
}

.text_main_box {
  display: flex;
}

/* 移动端样式 */
@media (max-width: 750px) {

  ::v-deep .el-textarea .el-textarea__inner {
    height: 80px;
  }

  .mx-auto {
    margin-top: 0;
  }
  .text-3xl {
    font-size: 22px;
  }
  .input_rate {
    width: revert;
    margin-top: 10px;
  }
  .container {
    width: 100%;
    max-width: 750px;
    min-width: 0px;
    padding-top: 60px;
    margin-top: 0px;
  }
  .balck {
    display: none;
  }
  .content_box {
    width: 100%;
    padding: 0 34px;
    box-sizing: border-box;
    max-width: 750px;
    //min-width: 450px;
  }
  .btn {
    width: 100%;
    margin-top: 16px;
  }


  .list-decimal div {
    word-wrap: break-word;
  }
  .mobile_text {
    display: flex;
    color: #C6FE61;
  }
  .pc_text {
    display: none;
  }
  .mobile_box {
    display: flex;
  }
  .pc_box {
    display: none;
  }
  .userInfo_box {
    .rounded-full {
      width: 40px;
      min-width: 40px;
      height: 40px;
    }

    .ml-auto {
      margin-top: 10;
      display: block;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
  .mb-4 {
    margin: 18px 0 !important;
  }
  .select_content_box {
    .lable_box {
      font-size: 13px;
      font-weight: 500;
    }

    display: revert;

  }
  .el_select_box {
    //height: 1.8rem;
    //width: 6.5rem;
    font-size: 8px;
    width: 200px;
    margin-top: 10px;

    .el_select_text {
      //font-size: 8px;
    }

    .el_select_icon_head {
      width: 0.9rem;
      height: 0.9rem;
      min-width: 0.9rem;
      font-size: 0.7rem;
      line-height: 0.9rem;
    }
  }
  .text-gray-400 {
    font-size: 13px;
    text-align: justify;
    line-height: 17px;
  }
  .checkbox_content_box {
    span {
      font-size: 12px;
    }
  }
  .btn {
    height: 40px;
    opacity: 1;
    border-radius: 6px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 2px;
  }
  .token {
    margin-left: 0px;
    margin-top: 10px;
    font-size: 11px;
  }
  ::v-deep .el-dialog {
    width: 307px !important;
    height: 360px;
  }
  ::v-deep .dialog-footer {
    .el-button {
      width: 125px;
      height: 28px;
      line-height: 28px;
      padding: revert;
    }
  }
  ::v-deep .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
    margin-left: 16px;
  }
  .pc_token {
    //display: none;
    overflow: hidden;

  }
  .mobile_token {
    display: block !important;
    margin-left: 0;
  }
  .select_content_box {
    margin: 18px 0 10px;
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close{
    font-size: 16px;
    color:white;
  }
  .demo-input-suffix{
    .lable{
      width: 34px;
      margin-right: 12px;
    }
    .rounded-full{
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
    .text{
      font-size: 12px;
    }
  }
  .el-textarea{
    height: 94px;
    font-size: 12px;
  }

  ::v-deep .el-input__inner {
    height: 25px;
    line-height: 25px;
    text-align: left;
    font-size: 12px;
  }

  ::v-deep .demo-input-suffix .el-input__inner {
    color: #ffffff !important;
    background: transparent !important;
    border: 1px solid #848E9C !important;
  }
  ::v-deep .el-dialog__title{
    font-size: 14px;
  }


  ::v-deep .el-dialog__body{
    padding-top: 10px;
    padding-bottom: 0px;
  }



}

.mobile_userInfo_box {
  display: block;
  margin-left: 13px !important;

  .name {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 16.41px;
    color: rgba(234, 236, 239, 1);
    margin-top: 2px;

  }

  .text {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 11.72px;
    color: rgba(198, 254, 97, 1);
    margin-top: 5px;
  }
}

@media (min-width: 750px) {
  .mobile_text {
    display: none;
  }
  .mobile_box {
    display: none;
  }

}




</style>
